module.exports = "https://web-assets.ifttt.com/packs/media/press/wsj-11606eef.svg";